export const toSnakeCase = (s) => s.toLowerCase().replace(/\W+/g,'_');
